import styled from 'styled-components';

export const Terminner = styled.div`
    padding: calc(100vw*(79.5/375)) calc(100vw*(17/375)) calc(100vw*(116/375)) calc(100vw*(17/375));
`
export const Maintit = styled.h1`
    font-size: calc(100vw*(16/375));
    font-weight: 500;
    padding-bottom :  calc(100vw*(15/375));
`
export const Maintit2 = styled(Maintit)`
    padding-bottom :  calc(100vw*(2/375));
    line-height: 1.5;
`

export const Subtit = styled.span`
    color: #ffc036;
`
export const Subcont = styled.p`;
    font-size: calc(100vw*(11/375));
    line-height: 1.36;
    color: #707070;
`

export const Fileinput = styled.input`
    display:none;
`
export const Filelabel = styled.label`
    display: block;
    width: calc(100vw*(140/375));
    height: calc(100vw*(140/375));
    background-color: #eaeaea;
    margin-top: calc(100vw*(20/375));
`
export const Fileimg = styled.span`
    display:block;
    width: calc(100vw*(34.5/375));
    height: calc(100vw*(28.2/375));
    margin: 0 auto;
    padding: calc(100vw*(55/375)) 0;
`

export const Pictureinner = styled.div`
`
export const PreviewInner = styled.div`
    display: flex;
    flex-wrap: wrap;
`
export const Preview = styled.div`
    display: block;
    width: calc(100vw*(140/375));
    height: calc(100vw*(140/375));
    margin-top: calc(100vw*(20/375));
    margin-right: calc(100vw*(15/375));
`
export const PreviewImg = styled.img`
    object-fit: cover;
    height: 100%;
    width: 100%;
`
export const PreviewImglist = styled.div`
    display: flex;
    flex-wrap: wrap;
`